import SkeletonBlock from '@loaders/SkeletonBlock';
import OnboardingPageLayout from '@modules/merchant/authentication/components/OnboardingPageLayout';
import { memo } from 'react';

const CreateProfilePageSkeleton = memo(() => (
  <OnboardingPageLayout>
    <div
      className="flex w-full flex-1 flex-col gap-page"
      aria-busy="true"
      aria-label="Loading create profile"
    >
      <div className="flex w-full flex-col gap-0.75 desktop:gap-1">
        <SkeletonBlock className="skeleton-title h-8 w-64 desktop:h-10" />
        <SkeletonBlock className="skeleton-line h-4.5 w-48 desktop:h-6" />
      </div>

      <div className="flex w-full flex-1 flex-col gap-field">
        <div className="flex w-full items-center gap-form">
          <SkeletonBlock className="skeleton-circle size-[52px] shrink-0 md:size-[66px] desktop:size-[88px]" />
          <SkeletonBlock className="skeleton-line h-5 w-36" />
        </div>

        <div className="flex w-full flex-col gap-1">
          <SkeletonBlock className="skeleton-line h-5 w-24" />
          <SkeletonBlock className="skeleton-field" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <SkeletonBlock className="skeleton-line h-5 w-24" />
          <SkeletonBlock className="skeleton-field" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <SkeletonBlock className="skeleton-line h-5 w-16" />
          <SkeletonBlock className="skeleton-field" />
        </div>

        <SkeletonBlock className="mt-auto h-8 w-full rounded-full desktop:h-11 sm:mt-4" />
      </div>
    </div>
  </OnboardingPageLayout>
));

CreateProfilePageSkeleton.displayName = 'CreateProfilePageSkeleton';

export default CreateProfilePageSkeleton;
